export default __webpack_public_path__ + "static/media/TableFill.78afb6c0.svg";